import { Tabs } from 'antd'

function ANTDTab({ ...props }) {
  return <Tabs {...props} />
}

export default ANTDTab
